import React, { Component } from 'react';
import { apiURL, change_date_format, teacherApiURL } from '../utils';  
import Footer from '../include/Footer';
import Header from '../include/Header';
import { makeStyles, withStyles } from '@material-ui/core/styles'; 
import { CssBaseline, Grid, Container, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,Table, TableBody, TableCell, TableHead, TableRow, Snackbar, Switch, InputAdornment, FormControl} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert'; 
import SearchIcon from '@material-ui/icons/Search';
import axios from 'axios';  
import Helmet from 'react-helmet';
import DateFnsUtils from '@date-io/date-fns';  
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"; 
import Moment from 'moment';  
import Box from '@material-ui/core/Box';
import { TableContainer } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import EditIcon from '@material-ui/icons/Edit';  
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import "../style/Style.css";  
import Meta from "../meta/Meta";
import Delete from "../delete/Delete";
const drawerWidth = 280;
// const useStyles = makeStyles((theme) => ({

// }))

const useStyles = theme => ({
    buttonEdit: {
        textTransform:'capitalize',
        border:'1px solid #035eab',
        borderRadius:'0px',
        marginRight:'10px',
        padding:'2px 5px',
      },
    buttonAdd:{
      textTransform:'capitalize',
    },
    table:{
        minWidth: 650,
    },
   
   
  });

 
 class Other_activities extends Component {
    _isMounted = false;
    constructor(props){
        super(props);
        this.state = {
           //drawerOpen: false,
            drawerOpen: true,
            showDialog: false, 
            teamData: [],
            page: 1,
            per:20,
            total_pages: null,
            loading: false, 
            showSnackbar: false,
            snackBarMessage: '',
            severityColor: '',
            imagePreview: null,
            file: null,
            imageEdit: false,
            mode: '',  
            selecteDate:  new Date(),
            changeDate: '', 
            noDta: '',
        }
        this.handleDrawerOpen       = this.handleDrawerOpen.bind(this);
        this.addDialog              = this.addDialog.bind(this);
        this.dialogClose            = this.dialogClose.bind(this);
        this.changeHandler          = this.changeHandler.bind(this);
        this.onFormSubmit           = this.onFormSubmit.bind(this);
        this.onEditFormSubmit       = this.onEditFormSubmit.bind(this);
        this.editDialogOpen         = this.editDialogOpen.bind(this); 
        this.changeStatus           = this.changeStatus.bind(this)
        this.handleDateChange       = this.handleDateChange.bind(this);
    }

    handleDrawerOpen(drawerState){
        this.setState({
          drawerOpen: drawerState,
        })
    }

    changeHandler = (e, type) => { 
        this.setState({ 
            [e.target.name]: e.target.value,
        }); 
    }

    handleDateChange = (date) => { 
        console.log(date) 
        this.setState({
            selecteDate: new Date(date), 
            changeDate: change_date_format(date)
        });
    }

    handleImageChange = (e) => {
        this.setState({  
            imagePreview: URL.createObjectURL(e.target.files[0]),
            file:e.target.files[0],
            imageEdit: true
         })
    }

    componentDidMount() { 
        this._isMounted = true; 
        this.teamListData(); 
        this.scrollListener = window.addEventListener("scroll", e => {
            this.handleScroll(e);
        });
        
    }

    componentWillUnmount() {
        this._isMounted = false; 
    }
  
    teamListData = () => {
        this.setState({ loading: true, noData: "" });
    
        const { per, page, teamData } = this.state;
        const headers = {
            "Content-type": "application/json",
        };
        const searchValue = document.getElementById("search").value || "";
    
        const body = { search: searchValue };
    
        axios
            .post(teacherApiURL(`other_activities?per_page=${per}&page=${page}`), body, { headers })
            .then((response) => {
                if (this._isMounted) {
                    const resultData = response.data;
    
                    if (resultData.status === true || resultData.status === 1) {
                        this.setState({
                            teamData: resultData.total < 20 ? resultData.result : [...teamData, ...resultData.result],
                            total_pages: resultData.total_pages,
                            scrolling: false,
                        });
                    } else if (resultData.status === false && resultData.message === "no data found") {
                        this.setState({
                            teamData: [],
                            noData: "No Activity Found",
                        });
                    }
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.setState({ noData: "Error fetching data, please try again" });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };
    
    loadMore = () => { 
        if(this._isMounted){
            this.setState(
            prevState => ({
                page: prevState.page + 1,
                scrolling: true
            }),
            this.teamListData
            ); 
        }
      };

      handleScroll = () => {   
        if(this._isMounted){ 
            var lastLi = document.querySelector("Table"); 
            if(lastLi !== null){
                var lastLiOffset = lastLi.offsetTop + lastLi.clientHeight;
                var pageOffset = window.pageYOffset + window.innerHeight;
                if (pageOffset > lastLiOffset) {
                    if(this.state.scrolling){
                        this.loadMore();
                    }
                } 
            }
        }
      };

    onFormSubmit = (e) => { 
        e.preventDefault();
        const headers = {
            'content-type': 'application/json',
            'Accept': 'application/json',
        }
        const formData  = new FormData();
        formData.append('file', this.state.file);
        formData.append('title', this.state.title);
        formData.append('select_date', this.state.selecteDate);  
        formData.append('video_url', this.state.video_url);  
        
        axios.post(teacherApiURL('other_activities/add'), formData, {headers: headers})
        .then(response => {
            const resultData = response.data; 
            if(resultData.status === true || resultData.status === 1)
            {
                this.dialogClose();
                this.componentDidMount();
                this.setState({ imageEdit: false, imagePreview: null, file: null  });  
                this.setState({ 
                    showSnackbar: true, 
                    snackBarMessage:  resultData.message,
                    severityColor: resultData.status === true?'success':'error',
                    snackBarTimer: 3000
                });
             }
             else{
                 this.setState({ 
                     showSnackbar: true, 
                     snackBarMessage:  resultData.message,
                     severityColor: 'error',
                     snackBarTimer: 2000
                 });
            }
            
        })
        .catch(error => {
            console.log(error)
        }) 
    }

    onEditFormSubmit = (e) => {
         e.preventDefault(); 
         const headers = {
             'content-type': 'application/json',
             'Accept': 'application/json'
         }
        
         const editFormData  = new FormData();
         editFormData.append('id', this.state.id);
         editFormData.append('title', this.state.title);
         editFormData.append('select_date', this.state.selecteDate); 
         editFormData.append('exist_file', this.state.image);
         editFormData.append('image_change', this.state.imageEdit);
         editFormData.append('video_url', this.state.video_url);
         if(this.state.file !== null){
             editFormData.append('file', this.state.file);
         }

         axios.post(teacherApiURL('other_activities/edit'),editFormData, {headers: headers})
         .then(response => {
             const resultData = response.data; 
             if(resultData.status === true || resultData.status === 1)
             {
                 this.setState({ imageEdit: false, imagePreview: null, file: null });
                 this.dialogClose();
                 this.componentDidMount();  
                 this.setState({ 
                    showSnackbar: true, 
                    snackBarMessage:  resultData.message,
                    severityColor: resultData.status === true?'success':'error',
                    snackBarTimer: 3000
                });
             }
             else{
                 this.setState({ 
                     showSnackbar: true, 
                     snackBarMessage:  resultData.message,
                     severityColor: 'error',
                     snackBarTimer: 2000
                 });
            }
         })
         .catch(error => {
             console.log(error)
         })
    }

    changeStatus = (id, status) => { 
        const changeStatus= status === 1 ? 0 : 1;
        const headers = { 
            'Content-type': 'application/json'
        }
        axios.get(teacherApiURL('other_activities/change_status/'+id+'/'+changeStatus), {headers: headers})
        .then(response => {
            const resultData = response.data; 
            if(resultData.status === true || resultData.status === 1)
            { 
                const updatedTeam = this.state.teamData.map(team=>{
                    if(team.fldi_id === id){
                        const _team = {...team};
                        _team.flg_status = status=== 0 ? 1 : 0;
                        return _team;
                    }
                    return  team;
                });
                this.setState({ teamData: updatedTeam, showSnackbar: true, 
                    snackBarMessage:  resultData.message,
                    severityColor: resultData.status === true?'success':'error',
                    snackBarTimer: 3000});
            }
        })
        .catch(error => {
            console.log(error)
        })
      }

    addDialog = (e) => { 
        this.setState({ 
            showDialog: true,
            mode: 'add', 
            title: '',
            file: '',
            image:'',
            video_url: e.fldv_video_url,
            image_capture: e.fldv_image_capture,
            selecteDate: new Date()
        });
    }

    editDialogOpen = (e) => { 
        this.setState({ 
            showDialog: true,
            mode: 'edit',
            id: e.fldi_id,
            title: e.fldv_title,
            video_url: e.fldv_video_url,
            image_capture: e.fldv_image_capture,
            image: e.fldv_image_url,
            selecteDate: new Date(e.fldv_selected_date),
        });  
    }

    dialogClose = () => { 
        this.setState({ showDialog: false });
    }

    snackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
          }
          this.setState({ showSnackbar: false }); 
    }

    searchHandler = (e) => {
        this.setState({page: 1, searchValue:e.target.value}, () => { 
            this.teamListData();  
          })
    }

    successDelete = (e, id, index) => {  
        if(e === true){
            const deleteData = this.state.teamData;
            deleteData.splice(index, 1);
            this.setState({
                teamData: deleteData, 
                showSnackbar: true, 
                snackBarMessage: "data deleted suceesfully", 
                severityColor: 'success',
                snackBarTimer: 3000
            }); 
        } 
    }
   
    render(){
        const { classes } = this.props; 
        const loadingCSS = {
            height: "30px",
            margin: "10px"
          };
        const loadingTextCSS = { display: this.state.loading ? "block" : "none" }; 
        return(
            <div>
                <Helmet>
                    <title>Video</title>
                </Helmet>
                <Header forwardDrawerOpen={this.handleDrawerOpen.bind(this)}  />
                <CssBaseline /> 
                <div style={{ paddingTop: '5rem', paddingLeft: (this.state.drawerOpen?drawerWidth+15:72+15), transition: 'padding 0.5s ease'   }}>
                    <main>    
                        <Container maxWidth="lg" > 
                        <Box  bgcolor="background.paper" mt={2} boxShadow={3}>
                        <Alert 
                            action={
                                <div>
                                    <TextField className="textField" type="text" placeholder="...Search"  
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            style: {color: '#414141',backgroundColor:'rgba(255, 255, 255, 0.29)'}
                                        }} 
                                        size="small"
                                        id="search"
                                        variant="outlined"
                                        style={{fontColor:"#fff", marginRight:'1rem',}} 
                                        name="search"
                                        onChange={e => this.searchHandler(e)} 
                                    /> 
                                    <Button className={classes.buttonAdd} variant="contained" color="primary" startIcon={<AddCircleOutlineOutlinedIcon/>}  onClick={this.addDialog}> Add Other Activities </Button>  
                                </div>
                            } 
                            variant="outlined" severity="default" boxShadow={3}><h2>Other Activities</h2>
                        </Alert>
                        </Box>
                            <Grid container spacing={3}  align="center" > 
                                <Grid item xs={12}>  
                                <Box  bgcolor="background.paper" boxShadow={3} px={2} py={2} mt={1}>
                                <TableContainer  mt={1} component={Paper} className="customTable">
                                    <Table size="small" stickyHeader aria-label="sticky table">
                                        <TableHead>     
                                            <TableRow>
                                                <TableCell>Id</TableCell> 
                                                <TableCell> Title </TableCell> 
                                                <TableCell> Date </TableCell> 
                                                <TableCell>Image</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody> 
                                            {this.state.teamData.map((arrList, index) => {    
                                             return <TableRow key={arrList.fldi_id}>  
                                                    <TableCell>{index+1}</TableCell> 
                                                    <TableCell>{arrList.fldv_title}</TableCell> 
                                                    <TableCell>{Moment(arrList.fldv_selected_date).format('D MMM, YYYY')}</TableCell> 
                                                    <TableCell><img style={{width:'25px', marginLeft:'10px'}} src={arrList.fldv_image_url} alt={arrList.fldv_name} /></TableCell>
                                                    <TableCell> <Switch size="small" checked={arrList.flg_status===1} color="primary" onChange={() => this.changeStatus(arrList.fldi_id, arrList.flg_status)}/></TableCell>
                                                    <TableCell>
                                                        <Button className={classes.buttonEdit} variant="outlined" color="default" onClick={() => this.editDialogOpen(arrList)} startIcon={<EditIcon style={{color:'#035eab', fontSize:'1rem',}} />}>Edit</Button>

                                                        <Delete deleteID={arrList.fldi_id} table={'other_activities'} onSuccessDelete={(e) => this.successDelete(e, arrList.fldi_id, index)}/>

                                                        {/* <Meta primaryId={arrList.fldi_id} useFor={"inner_page"} table={'other_activities'} onSuccessDelete={(e) => this.successDelete(e, arrList.fldi_id, index)}/> */}
                                                        
                                                    </TableCell>
                                                </TableRow>
                                            })} 
                                        </TableBody>
                                    </Table> 
                                    </TableContainer>
                                    </Box>
                                    <div ref={loadingRef => (this.loadingRef = loadingRef)} style={loadingCSS} >
                                        <span style={loadingTextCSS}>Loading...</span>
                                        <span>{this.state.noData && this.state.teamData.length === 0 ? this.state.noData:""}</span>
                                    </div>
                                    
                                </Grid>
                           </Grid> 
                           <Footer />
                        </Container>
                    </main>
                </div> 

                <Dialog open={this.state.showDialog} fullWidth={true} maxWidth={'sm'}>
                    <form  id="courses" ref={c => { this.form = c }} onSubmit={this.state.mode === 'edit'?(e) => this.onEditFormSubmit(e):(e) => this.onFormSubmit(e) }  >
                        <DialogTitle id="form-dialog-title"><h3 style={{textAlign:'center'}}>{(this.state.mode === 'add')?'Add':'Edit'} Other Activites </h3></DialogTitle>
                        <DialogContent style={{overflowY: 'hidden'}}>  
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12}>   
                                    <TextField fullWidth type="text" label="Title" variant="outlined" name="title"  size="small" onChange={ e => this.changeHandler(e)} value={this.state.title}  />
                                </Grid>

                                <Grid item xs={12} sm={12}>          
                                    <MuiPickersUtilsProvider size="small" utils={DateFnsUtils} >
                                        <FormControl size="small" style={{width:'100%'}} >  
                                            <KeyboardDatePicker  size="small" InputProps={{size:"small"}} inputVariant="outlined" label="Choose Date" value={this.state.selecteDate}
                                                onChange={(date) => this.handleDateChange(date)}  name="date" format="dd/MM/yyyy"
                                                showTodayButton minDate={new Date(this.state.selecteDate)} autoOk variant="inline"
                                            /> 
                                        </FormControl>
                                    </MuiPickersUtilsProvider>
                                </Grid>  
								
                                <Grid item xs={12} sm={12}>   
                                    <TextField fullWidth type="text" label="Video Url" variant="outlined" name="video_url"  size="small" onChange={ e => this.changeHandler(e)} value={this.state.video_url}  />
                                </Grid>
                                
                                <Grid item xs={12} sm={12}>
                                {this.state.imageEdit === true?<img style={{width:'40px', display:'flex', marginBottom:'1rem', marginLeft:'12%'}} src={this.state.imagePreview}/>:<img style={{width:'40px', display:'flex', marginBottom:'1rem', marginLeft:'12%'}} src={this.state.image}/>}
                                    <Button variant="contained" color="primary" startIcon={<ImageSearchIcon/>} component="label">Choose Image
                                        <input type="file"  style={{ display: "none" }} onChange={this.handleImageChange} />
                                    </Button> 
                                   
                                </Grid>  
                             </Grid>
                        </DialogContent>
                        <DialogActions className="buttonCancel">
                            <Button variant="contained" onClick={() => this.dialogClose()} color="secondary"> Cancel </Button>
                            <Button type="submit" variant="contained" color="primary"> Submit </Button>
                        </DialogActions>
                    </form>
                </Dialog>

                <Snackbar open={this.state.showSnackbar === true} autoHideDuration={this.state.snackBarTimer} onClose={this.snackBarClose}>
                    <Alert onClose={this.snackBarClose} severity={this.state.severityColor} elevation={6} variant="filled">
                    { this.state.snackBarMessage }
                    </Alert>
                </Snackbar>
            </div>
        );
    }
 }
  
 export default (withStyles)(useStyles)(Other_activities);